const contentLink = () => import("@/pages/content/link/index.vue");
const contentLinkForm = () => import("@/pages/content/link/form.vue");

export default [
    {
        path: "/content/link",
        component: contentLink,
        meta: [
            {
                name: "内容管理",
                activeRoute: "/content/manage",
            },
            {
                name: "友情链接管理",
                activeRoute: "/content/link",
            },
        ],
    },
    {
        path: "/content/link/form",
        component: contentLinkForm,
        meta: [
            {
                name: "内容管理",
                activeRoute: "/content/manage",
            },
            {
                name: "友情链接管理",
                url: "/content/manage",
            },
            {
                name: "新增/编辑",
                activeRoute: "/content/link",
            },
        ],
    },
];
